import React from 'react';
import styled from '@emotion/styled';
import { Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import SuccessOrderConfirmationImg from './assets/success-order-confirmation.svg';

const defaultHeader = <h1>Order received</h1>;
const defaultIcon = SuccessOrderConfirmationImg as any;
const StyledSuccessScreenWrapper = styled.div`
  padding-top: 10%;
`;

const StyledContentWrapper = styled.div({
  maxWidth: '440px',
});

const StyledSuccessImgV2 = styled.img({
  marginBottom: '20px',
  height: '96px',
  width: '96px',
});

const StyledContentRow = styled.div({
  marginBottom: '15px',
});

const StyledHeadingWrapper = styled(StyledContentRow)({
  marginBottom: '20px',
});

const StyledActionWrapper = styled.div({
  marginTop: token('space.200'),
  display: 'flex',
  justifyContent: 'space-between',
  gap: token('space.200'),
});

export type SuccessOrderConfirmationProps = {
  content?: React.ReactNode | null;
  icon?: any;
  header?: React.ReactNode;
  actions?: React.ReactNode;
};

export const SuccessOrderConfirmation = ({
  icon = defaultIcon,
  header = defaultHeader,
  content = null,
  actions,
}: SuccessOrderConfirmationProps) => {
  return (
    <StyledSuccessScreenWrapper>
      <Flex alignItems="center" direction="column">
        <StyledSuccessImgV2 src={icon as any} />
        <StyledHeadingWrapper>{header}</StyledHeadingWrapper>
        {content && <StyledContentWrapper>{content}</StyledContentWrapper>}
        <StyledActionWrapper>{actions}</StyledActionWrapper>
      </Flex>
    </StyledSuccessScreenWrapper>
  );
};
